import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import * as WizardActions from '../../../actions/WizardActions';
import * as FileTypeConstants from '../../../../common/constants/FileTypeConstants';
import {MODAL_TYPE} from '../../../constants/ModalConstants';
import * as ModalActions from '../../../actions/ModalActions';
import {BankTarget} from '../../../types/mx/types';
import FilesSectionView from '../../../components/views/mx/turboCash/FilesSectionView';

const mapStateToProps = (state, {match, showErrors}) => {
    const files = state.turboCash.loanApplication.files;

    return {
        showErrors,
        ifeFrontFiles: files.identification.ifeFrontFiles,
        ifeBackFiles: files.identification.ifeBackFiles,
        carLicenceFrontFiles: files.carLicence.carLicenceFrontFiles,
        carLicenceBackFiles: files.carLicence.carLicenceBackFiles,
        homeFiles: files.home.homeFiles,
        otherMonth1Files: files.other.otherMonth1Files,
        otherMonth2Files: files.other.otherMonth2Files,
        otherMonth3Files: files.other.otherMonth3Files,
        loanApplicationToken: match.params.token
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onDropIdentificationFiles: (files, type, section, error) => {
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDropHomeFiles: (files, type, section, error) => {
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDropOtherFiles: (files, type, section, error) => {
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDropCarLicenceFiles: (files, type, section, error) => {
            dispatch(WizardActions.PROCESS_FILES_TO_UPLOAD_ACTION.action(
                files, type, section, error, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDeleteIdentificationFile: (id) => {
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.IDENTIFICATION_TYPE, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDeleteHomeFile: (id) => {
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.HOME_TYPE, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDeleteOtherFile: (id) => {
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.OTHER_TYPE, BankTarget.TURBO_CASH_STATE
            ));
        },
        onDeleteCarLicenceFile: (id) => {
            dispatch(WizardActions.DELETE_FILE_ACTION.action(
                id, FileTypeConstants.DRIVER_LICENSE_TYPE, BankTarget.TURBO_CASH_STATE
            ));
        },
        onClickThumbnail: (item) => {
            const content = {
                type: MODAL_TYPE.SHOW_FILE_IMG_VIEW,
                data: item
            };
            const options = {
                closeOnOverlayClick: true,
                size: 'small'
            };
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action(null, content, null, options));
        },
    };
};

const mergeProps = (stateProps, dispatchProps) => {
    return {
        ...stateProps,
        ...dispatchProps
    };
};

const FilesSectionContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(FilesSectionView));

export default FilesSectionContainer;